import React, { useState, useEffect } from 'react';
import {
    Drawer,
    DrawerBody,
    DrawerFooter,
    DrawerHeader,
    DrawerOverlay,
    DrawerContent,
    DrawerCloseButton,
} from '@chakra-ui/react';
import { updateArea } from '../../redux/api/areaApi/AreaApi';
import NewTable from './Newtable.js'
import ProgressBar from '../../utils/progressBar/ProgressBar';
import { updateAreaAction } from '../../redux/reduxSlice/AreaSlice';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { addArea } from '../../redux/api/areaApi/AreaApi';
import { addAreaAction } from '../../redux/reduxSlice/AreaSlice';

function AreaForm(props) {
    const dispatch = useDispatch();
    const { isUpdateMode, dataToEdit, formData: initialFormData, setIsUpdateMode, areaROWID } = props;
    const [showProgressBar, setShowProgressBar] = useState(false);
    const [formData, setFormData] = useState({
        breakDown: [],
    });
    useEffect(() => {
        console.log({ isUpdateMode, dataToEdit })
        if (isUpdateMode && dataToEdit) {
            const area = {
                title: dataToEdit.areas.areaName,
                rows: [...JSON.parse(dataToEdit.areas.tasks)],
                parentId: dataToEdit.areas.parentId,
                parentModule: dataToEdit.areas.parentModule,
                ROWID: dataToEdit.areas.ROWID
            };
            console.log({ area })
            setFormData({ breakDown: [area] });
        }
    }, [isUpdateMode, dataToEdit]);
    useEffect(() => {
        console.log({ formData })
    }, [formData]);
    const handleOnClose = () => {
        props.closeAreaDrawer();
        setIsUpdateMode(false);
    };
    const getData = (data, type) => {
        setFormData((prev) => ({ ...prev, breakDown: data }))
    };
    // Handle Update Function
    const handleUpdate = (e) => {
        e.preventDefault()
        setShowProgressBar(true)
        updateArea(formData).then((response) => {
            console.log({ response })
            if (response.data.success) {
                setFormData((prev) => ({
                    ...prev, ROWID: response?.data.ROWID
                }))
                dispatch(updateAreaAction(formData))
                toast.success("Area Updated SuccesFully !!")
            }
            setTimeout(() => {
                handleOnClose();
                setShowProgressBar(false);

            }, 300);
        }).catch((error) => {
            console.log(error)
            toast.error("Area Updation Failed !")
        }).finally(() => {

        });
    }
    // Handle Submit Function
    const handleSubmit = (e) => {
        e.preventDefault();
        setShowProgressBar(true);
        addArea(formData).then((response) => {
            if (response.data.success) {
                dispatch(addAreaAction(response.data));
                toast.success("Area Created Successfully!!");
                setFormData({
                    tab: [],
                    columns: ['Action', 'Task'],
                });
            }
            setTimeout(() => {
                handleOnClose();
                setShowProgressBar(false);
            }, 300);
        }).catch((error) => {
            console.error("API Error", error);
            toast.error("Area Creation Failed!");
            setShowProgressBar(false);
        });
    };

    return (
        <div>
            <Drawer
                isOpen={props.areaOpen}
                placement="right"
                onClose={handleOnClose}
                size="xl">
                <DrawerOverlay />
                <DrawerContent>
                    <DrawerCloseButton />
                    <DrawerHeader>{isUpdateMode ? "Update Area" : "Create Area"}</DrawerHeader>
                    <DrawerBody>
                        <NewTable getData={getData} breakDown={formData.breakDown} />
                    </DrawerBody>
                    <center><DrawerFooter style={{ display: 'inline-block' }} >
                        <div className='gap-3 d-flex'>
                            <button variant='outline' mr={3} onClick={handleOnClose} className="cancel-button">
                                Reset
                            </button>
                            <button className='create-button' onClick={(e) => { !isUpdateMode ? handleSubmit(e) : handleUpdate(e) }} >{isUpdateMode ? "Update" : "Submit"}</button>
                        </div>
                    </DrawerFooter></center>
                </DrawerContent>
            </Drawer>
            {showProgressBar && <ProgressBar />}
        </div>
    );
}
export default AreaForm;
